import http from "./index"
function getData(params) {
    return http.post('/article/where', params)
}

function editData(params) {
    return http.put('/article', params)
}

function getArticleData(params) {
    return http.get(`/article/querybyid?id=${params}`)
}


function getBannerList(params) {
    return http.post('/home/kingname/getKingBanner', params)
}

//获取坤策官网首页轮播图
function getBannerLists(params) {
    return http.post('/banner/selectKingBanner', params)
}

export default {
    getData,
    editData,
    getBannerList,
    getBannerLists,
    getArticleData
}


// WEBPACK FOOTER //
// ./src/api/api.js